/**
 * Adzuki.PasswordRequirements
 */

(function PasswordRequirements($, Adzuki)
{
	"use strict";

	var PasswordRequirements = {};

	// THESE ARE RE-RESOLVED BY init(), NOT CAPTURED ONCE - SET-25.
	//
	// They used to be assigned here, at module scope, and bound at $(document).ready. That works
	// for a form present in the page when it loads, which is every screen that used this until
	// now. It reaches NOTHING on a panel delivered by AJAX: the settings modal replaces its
	// markup on every render, so the cached sets point at elements that were never in the
	// document, and the guidelines and strength meter sit inert.
	//
	// Same shape as AgentsEditForm.js before SET-16 moved its wiring into form.load().
	var $password_input      = $();
	var $password_guidelines = $();
	var $password_meter      = $();
	var $button              = $();

	// SET-25: 'none' IS THE RESTING STATE AND HAS TO BE A LEVEL OF ITS OWN.
	//
	// An empty field is not a weak password, it is no password - and every screen that uses
	// this ships markup reading "Strength" for exactly that reason. Without a level to name it,
	// drawing the resting state printed the weak label instead, which is what QA found.
	PasswordRequirements.strengthLevels = {
		none  : 'Strength',
		weak  : "That's weak",
		medium: "Getting there",
		strong: "Stronger password"
	};

	// show success or error for every guideline item listed
	PasswordRequirements.applyGuidelinesUi = function applyGuidelinesUi(errors)
	{
		$password_guidelines.each(function matchError(e)
		{
			var item = $(this);

			if ($.inArray(item.attr('id'), errors) === -1) {
				PasswordRequirements.guidelineItemError(item);
			} else {
				PasswordRequirements.guidelineItemSuccess(item);
			}
		});
	};

	// adjust meter according to strength of pw
	PasswordRequirements.applyMeterUi = function applyMeterUi(strength)
	{
		var lower = (strength || 'none').toLowerCase();

		// SET-25: REMOVE ONLY THE LEVELS THIS FUNCTION OWNS.
		//
		// This was a bare removeClass(), which strips EVERY class on the element - including the
		// one the panel styles it with. .my-settings-password-meter is a real rule, so the meter
		// lost its styling the moment this ran; and because init() runs it to draw the resting
		// state, that happened on render, before the advisor typed anything.
		//
		// Harmless on the legacy screens, whose meter carries no class at all - which is why it
		// survived until this widget was reused inside a styled panel.
		$password_meter.removeClass('none weak medium strong');
		$password_meter.text(this.strengthLevels[lower] || this.strengthLevels.none);
		$password_meter.addClass(lower);
	};

	// apply all UI changes according to the strength of the potential pw
	PasswordRequirements.applyUi = function applyUi(strength_results)
	{
		this.applyMeterUi(strength_results.strength);
		this.applyGuidelinesUi(strength_results.errors);

		// toggle button
		if (strength_results.strength === 'Strong') {

			$button.removeClass('disabled');
			$button.prop("disabled", false);
		} else {
			$button.addClass('disabled');
			$button.prop("disabled", true);
		}
	};

	// NAMED THE INVERSE OF WHAT THEY PAINT - READ THE BODIES, NOT THE NAMES.
	//
	// guidelineItemError() paints the rule GREEN WITH A TICK and guidelineItemSuccess() paints it
	// bold red without one, which is the opposite of what both names and both comments say. The
	// pairing with applyGuidelinesUi() is what makes the screen come out right: `errors` holds the
	// ids that FAILED, so an id NOT in it is a rule that passed and gets guidelineItemError().
	//
	// LEFT AS THEY ARE RATHER THAN RENAMED, deliberately: four screens load this file and a rename
	// mid-QA is churn. But it cost a defect on 9 Oct 2026 - a fix for the resting state passed an
	// empty `errors` meaning "nothing failed", which rendered every guideline green on an empty
	// field. If these are ever renamed, that is the trap being removed.
	PasswordRequirements.guidelineItemError = function guidelineItemError($el)
	{
		$el.removeClass("text-bold");
		$el.removeClass("text-danger");
		$el.addClass("text-success");
		$el.find("i").removeClass("hidden"); // show checkmark
	};

	// guideline is met, de-emphasize in UI
	PasswordRequirements.guidelineItemSuccess = function guidelineItemSuccess($el)
	{
		$el.addClass("text-bold");
		$el.removeClass("text-success");
		$el.addClass("text-danger");
		$el.find("i").addClass("hidden"); // hide checkmark
	};

	// test the strength of a string that a user is attempting to make a password
	// uses same logic as ValidationComponent->_password()
	//
	// errors keys match up with ids within adzuki\templates\elements\PasswordRequirementsElement.php
	PasswordRequirements.testStrength = function testStrength(str)
	{
		var errors       = [],
			responseObj  = {strength: "Weak"},
			score        = 0,
			_str         = str.trim(),
			min_length   = 8, // default minimum length
			strong_score = 0,
			med_score    = 0;

		// At least X characters, excluding white space
		if ($('#password-min-characters').length > 0) {
			strong_score++;
			min_length = parseInt($('#char-count').html());

			if (_str.length < min_length) {
				errors.push("password-min-characters");
			} else {
				score++;
			}
		}

		// At least one CAPITAL letter
		if ($('#password-one-capital-letter').length > 0) {
			strong_score++;

			if ((/[A-Z]+/).test(_str) === false) {
				errors.push("password-one-capital-letter");
			} else {
				score++;
			}
		}

		// At least one lowercase Letter
		if ($('#password-one-lowercase-letter').length > 0) {
			strong_score++;

			if ((/[a-z]+/).test(_str) === false) {
				errors.push("password-one-lowercase-letter");
			} else {
				score++;
			}
		}

		// At least one Number
		if ($('#password-one-number').length > 0) {
			strong_score++;

			if ((/[0-9]+/).test(_str) === false) {
				errors.push("password-one-number");
			} else {
				score++;
			}
		}

		// At least one special character
		if ($('#password-one-special-char').length > 0) {
			strong_score++;

			if ((/[\W]+/).test(_str) === false) {
				errors.push("password-one-special-char");
			} else {
				score++;
			}
		}

		med_score = (strong_score - 2);

		if (score >= med_score && score < strong_score) {
			responseObj.strength = "Medium";
		} else if (score >= strong_score) {
			responseObj.strength = "Strong";
		}

		// SET-25: AN EMPTY FIELD IS NO PASSWORD, NOT THE WEAKEST ONE - and ONLY the meter label
		// changes. The rules above have already run and failed, every one of them, which is the
		// right state for an untouched field.
		//
		// CORRECTED 9 Oct 2026, SAME DAY, AFTER QA. The first version returned early here with an
		// EMPTY errors list, which reads as "no rule failed" - so every guideline rendered as MET,
		// green and ticked, for a field with nothing in it. Setting the label at the end instead
		// leaves the evaluation alone, which is all that needed changing.
		if (_str === '') {
			responseObj.strength = 'None';
		}

		responseObj.errors = errors;
		return responseObj;
	};

	/**
	 * Finds this screen's password widgets and wires them. Safe to call again.
	 *
	 * NAMESPACED AND off BEFORE on, because the settings modal calls this on every panel render
	 * and a handler bound twice runs twice. The elements are usually new each time, but a render
	 * that reuses a node would otherwise stack.
	 */
	PasswordRequirements.init = function init()
	{
		$password_input      = $('.monitor-password-changes');
		$password_guidelines = $('.password-requirements').find('.pw-rule');
		$password_meter      = $('#password_meter');

		// PRODUCTION'S SAVE GATE, AND IT IS DELIBERATELY ABSENT FROM THE MODAL. The legacy
		// screens carry a .save-password button that this disables until every rule passes; the
		// settings surface has one Save in the top bar whose disabled state means "nothing to
		// save" everywhere (ground rule 1), so S38 rules the gate out here. No such button is
		// rendered in the panel, so this resolves empty and every call on it is a no-op.
		$button = $('.save-password');

		if ($password_input.length === 0) {
			return;
		}

		$password_input.off('keyup.pwreq change.pwreq').on('keyup.pwreq change.pwreq', function onType() {
			PasswordRequirements.applyUi(PasswordRequirements.testStrength($(this).val()));
		});

		// DRAW THE RESTING STATE IMMEDIATELY. A panel arriving with an empty field should show
		// every rule unmet and the meter reading "Strength", rather than whatever the markup
		// happens to ship with.
		PasswordRequirements.applyUi(PasswordRequirements.testStrength($password_input.val() || ''));
	};

	$(document).ready(function documentReady()
	{
		PasswordRequirements.init();

		// the settings modal replaces its panel on every render, so the widgets are new elements
		// each time and have to be found again
		$(document).on('my-settings:rendered', function panelRendered() {
			PasswordRequirements.init();
		});
	});

	Adzuki.PasswordRequirements = PasswordRequirements;

}(jQuery, window.Adzuki || {}));
